import React, { useState } from 'react';
import { authUser } from '../../firebase/config';

const PasswordChange = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleChangePassword = async (e) => {
        e.preventDefault();
        setMessage('');
        if (newPassword.length < 6) {
            setMessage('كلمة المرور يجب أن تكون 6 أحرف على الأقل');
            return;
        }
        if (newPassword !== confirmPassword) {
            setMessage('كلمة المرور غير متطابقة');
            return;
        }
        setLoading(true);
        try {
            await authUser.currentUser.updatePassword(newPassword);
            setMessage('تم تغيير كلمة المرور بنجاح ✓');
            setNewPassword('');
            setConfirmPassword('');
        } catch (err) {
            if (err.code === 'auth/requires-recent-login') {
                setMessage('يجب إعادة تسجيل الدخول أولاً لتغيير كلمة المرور. قم بتسجيل الخروج ثم الدخول مرة أخرى.');
            } else {
                setMessage('خطأ: ' + err.message);
            }
        }
        setLoading(false);
    };

    return (
        <div className="container my-4">
            <h4 className="text-center mb-4">تغيير كلمة المرور</h4>
            <div className="card shadow-sm mx-auto" style={{ maxWidth: 450 }}>
                <div className="card-body">
                    <p className="text-muted text-center mb-3">
                        الحساب: {authUser.currentUser?.email}
                    </p>
                    <form onSubmit={handleChangePassword}>
                        <div className="mb-3">
                            <label className="form-label">كلمة المرور الجديدة</label>
                            <input type="password" className="form-control" value={newPassword}
                                onChange={e => setNewPassword(e.target.value)} placeholder="6 أحرف على الأقل" required />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">تأكيد كلمة المرور</label>
                            <input type="password" className="form-control" value={confirmPassword}
                                onChange={e => setConfirmPassword(e.target.value)} placeholder="أعد كتابة كلمة المرور" required />
                        </div>
                        {message && (
                            <div className={`alert ${message.includes('✓') ? 'alert-success' : 'alert-danger'} py-2`}>
                                {message}
                            </div>
                        )}
                        <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                            {loading ? 'جاري التغيير...' : 'تغيير كلمة المرور'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PasswordChange;
